export class SubstationTemplateStat {
  templateId: number;
  templateName: string;
  voltageClass: string | null;
  count: number;
  previousMonthTotal: number;
  countIncrease: number;
  increasePercentage: number;
  symbol: string | null;
  color: string | null;

  constructor(data?: any) {
    this.templateId = data?.substationTemplateId ?? 0;
    this.templateName = data?.substationTemplateName ?? '';
    this.voltageClass = data?.voltageClass ?? null;
    this.count = data?.count ?? 0;
    this.previousMonthTotal = data?.previousMonthTotal ?? 0;
    this.countIncrease = data?.countIncrease ?? 0;
    this.increasePercentage = data?.increasePercentage ?? 0;
    this.symbol = data?.visualizationConfiguration?.symbol ?? null;
    this.color = data?.visualizationConfiguration?.color ?? null;
  }
}
